export { OgLocaleAlternates } from './OgLocaleAlternates';
